(function nearbysCardClicksModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  
  // Get container for nearby, if it exists
  const nearbysContainer = document.querySelector('[data-nearbys]');

  // Open the link when card is clicked
  const openCardLink = (event) => {
    const target = event.target;
    const card = target.closest('[data-standard-card]');
    if (!card) {
      return;
    }

    if (target.closest('[data-favorite-trigger]')) {
      return;
    }

    const link = card.querySelector('[data-link]');
    if (!link) {
      return;
    }

    if (link === target) {
      return;
    }

    window.open(link.href, '_blank');
  };

  const handleCardClicks = () => {
    if (nearbysContainer) {
      nearbysContainer.addEventListener('click', openCardLink);
    }
  };

  handleCardClicks();
}(window));